import React, { Component } from 'react';
import './../css/Actividad.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { faHome, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import BootstrapTable from 'react-bootstrap-table-next';
import { Col, Row, Container } from 'react-bootstrap';
import { ReactComponent as EditarIcon } from './../../img//svg/Editar.svg';
import { ReactComponent as EliminarIcon } from './../../img//svg/Eliminar.svg';
import enviar from './../../img/svg/Enviar(blanco).svg';
import Swal from 'sweetalert2'


function color_head_resumen(tipo) {
    if (tipo == 'id') {
        return {
            backgroundColor: '#E7E7E7',
            color: '#58A7E0', fontSize: 11,
            width: '5%'
        };
    } else if (tipo == 'dyo') {
        return {
            backgroundColor: '#E7E7E7',
            color: '#58A7E0', fontSize: 11,
            width: '45%'
        }
    } else if (tipo == 'h') {
        return {
            backgroundColor: '#E7E7E7',
            color: '#58A7E0', fontSize: 11,
            width: '15%'
        };
    } else {
        return {
            backgroundColor: '#E7E7E7',
            color: '#58A7E0', fontSize: 11,
            width: '15%'
        };
    }
}

function color(rowIndex) {
    if (rowIndex % 2 === 0) {
        return {
            backgroundColor: 'white'
        };
    }
    return {
        backgroundColor: '#E7E7E7'
    };
}

export class Resumen_Observaciones extends Component {
    static displayName = Resumen_Observaciones.name;

    constructor(props) {
        super(props);
        this.state = {
                solicitudes: [],  accion: "",loading: false, loading2: false
        }; 
    }

    componentDidMount() { 
        this.setState({
            solicitudes:this.props.solicitudes,
        }) 
    }

    get_radios(termino1, termino2, termino3, anio) {
        var respu;
        if (termino2 === "2" && termino1 === "1" && termino3 === "0") {
            return (
                'PAE-' + anio + '\n  PAO-' + anio + '-1\n PAO-' + anio + '-2'
            )
        }
        else if (termino1 === "1") {
            if (termino1 === "1" && termino3 === "0") {
                return (
                    'PAO-' + anio + '-1 \nPAE-' + anio
                );
            } else if (termino2 === "2" && termino1 === "1") {
                return (
                    'PAO-' + anio + '-1 \nPAO-' + anio + '-2'
                );

            } else {
                return (
                    'PAO-' + anio + '-1'
                );
            }
        } else if (termino2 === "2") {
            if (termino2 === "2" && termino1 === "1") {
                return (
                    'PAO-' + anio + '-1\n PAO-' + anio + '-2'
                );

            } else if (termino2 === "2" && termino3 === "0") {
                return (
                    'PAO-' + anio + '-2\n PAE-' + anio
                );
            }
            return (
                'PAO-' + anio + '-2'
            );
        } else if (termino3 === "0") {
            if (termino3 === "0" && termino1 === "1") {
                return (
                    'PAE-' + anio + '\n PAO-' + anio + '-1'
                );

            } else if (termino3 === "0" && termino2 === "2") {
                return (
                    'PAE-' + anio + '\n PAO-' + anio + '-2'
                );
            }
            return (
                'PAE-' + anio
            );
        }
    }

    render() {
        let radios = this.get_radios(this.props.termino1, this.props.termino2, this.props.termino3, this.props.anio);
        let dato = this.props.solicitudes.filter(x => x.ambito == 'M|R')
        let titulo =""
        if (this.props.tipoactividad === 'R') {
            titulo = "DOCENCIA DE GRADO"
        } else if (this.props.tipoactividad === 'P') {
            titulo = "DOCENCIA DE POSTGRADO"
        } else if (this.props.tipoactividad === 'I') {
            titulo = "INVESTIGACIÓN"
        } else if (this.props.tipoactividad === 'V') {
            titulo = "VINCULACIÓN"
        } else if (this.props.tipoactividad === 'G') {
            titulo = "GESTIÓN ACADÉMICA"
        } else {
            titulo = "DOCENCIA DE ADMISIÓN"
        }

        const columns_resumen = [{
            dataField: 'id',
            text: '#',

            headerStyle: color_head_resumen('id'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div>
                        {rowIndex + 1}
                    </div>
                )
            },
            footer: ''
        }, {
            dataField: 'idactividad',
            text: '#',
            hidden: true,
            headerStyle: color_head_resumen('id'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        }, {
            dataField: 'descripcion',
            text: 'Descripción',
            headerStyle: color_head_resumen('dyo'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        },
        {
            dataField: 'termino',
            text: 'Periodo',
            headerStyle: color_head_resumen('h'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row, rowIndex) => {
                //if (row.pao2 == "2" && row.pao1 == "1" && row.pae == "0") {
                //    return (
                //        <> PAE {row.anio}<br />PAO {row.anio}-1<br /> PAO {row.anio}-2</>
                //    )
                //}
                //else if (row.pae1 == "1") {
                //    if (row.pae1 == "1" && row.pae == "0") {
                //        return (
                //            <>PAO {row.anio}-1<br /> PAE {row.anio}</>
                //        );
                //    } else if (row.pao2 == "2" && row.pao1 == "1") {
                //        return (
                //            <>PAO {row.anio}-1<br /> PAO {row.anio}-2</>
                //        );
                //    } else {
                //        return (
                //            <>PAO {row.anio}-1</>
                //        );
                //    }
                //} else if (row.pao2 == "2") {
                //    if (row.pao2 == "2" && row.pao1 == "1") {
                //        return (
                //            <>PAO {row.anio}-1<br /> PAO {row.anio}-2</>
                //        );

                //    } else if (row.pao2 == "2" && row.pae == "0") {
                //        return (
                //            <>PAO {row.anio}-2<br /> PAE {row.anio}</>
                //        );
                //    }
                //    return (
                //        <>PAO {row.anio}-2</>
                //    );
                //} else if (row.pae == "0") {
                //    if (row.pae == "0" && row.pao1 == "1") {
                //        return (
                //            <>PAE {row.anio}<br /> PAO {row.anio}-1</>
                //        );

                //    } else if (row.pae == "0" && row.pao2 == "2") {
                //        return (
                //            <>PAE {row.anio}<br /> PAO {row.anio}-2</>
                //        );
                //    }
                //    return (
                //        <>PAE {row.anio}</>
                //    );
                //} else {
                //    return (
                //        <> {row.termino}</>
                //    );
                //}
                if (row.ambito.split('|')[0] == 'A') {
                    return (
                        <> {row.termino.replace(' ','\n')}</>
                    );
                }
                    
                else {
                    return (
                        <> {row.termino}</>
                    );
                }

            },
            footer: ''
        }, {
            dataField: 'totalhoras',
            text: 'Horas',
            headerStyle: color_head_resumen(''),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        }, {
            dataField: 'accion',
            text: 'Acción',
            headerStyle: color_head_resumen('h'),
            style: (cell, row, rowIndex, colIndex) => {
               return color(rowIndex)
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div>
                        <span className="badge badge-pill badge-warning" > {row.accion.toUpperCase()}</span>
                    </div>
                )
            },
           footer: ''
        },
        {
            dataField: 'observacion',
            text: 'Observación',
            headerStyle: color_head_resumen('dyo'),
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div>
                        { row.observacion.toUpperCase()}
                    </div>
                )
            },
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        }
        ];
       // console.log(this.props)
        return (
            <div>
                <Row>
                    <Col md="7">
                        <h4 className='resumen'>RESUMEN DE OBSERVACIONES DEL ÁMBITO { titulo }</h4>
                    </Col>
                    <Col md="5"><hr />
                    </Col>
                </Row>
                {this.props.solicitudes && this.props.solicitudes.length > 0 ?
                    <BootstrapTable
                        keyField='idactividad'
                        title='RESUMEN DE OBSERVACIONES DEL ÁMBITO '
                        data={this.props.solicitudes.filter(x => x.ambito == 'M|' + this.props.tipoactividad || x.ambito == 'A|' + this.props.tipoactividad)}
                        columns={columns_resumen}
                        bordered={false}
                    /> : null
                }
            </div>
        );
    }


}
